// extracted by mini-css-extract-plugin
export default {"modal-header":"AddHolidayManuallyModal_modal-header__RdEaV","form-container-head-warning":"AddHolidayManuallyModal_form-container-head-warning__qHu+m"};